<template>
  <div id="glass-units-mobile">
    <div class="filtered-count">Rasta: {{total}}</div>
    <v-card class="glass-unit-card" height="120px" v-for="(glassUnit, i) in glassUnits" :key="i">
      <div class="glass-unit-info">Užs: {{glassUnit.customer_order}}</div>
      <div class="glass-unit-info">Poz: {{glassUnit.customer_position}}</div>
      <div class="glass-unit-info">BxH: {{glassUnit.width}} x {{glassUnit.height}}</div>
      <div class="glass-unit-info">Tipas: {{glassUnit.type}}</div>
      <div class="glass-unit-info">Stovas: {{glassUnit.stand_number}}/{{glassUnit.stand_side}}</div>
    </v-card>
    <div class="text-xs-center pt-2">
      <v-pagination v-model="page" :length="pages"></v-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "glass-units-mobile",
  props: ["glassUnits", "total"],
  data() {
    return {
      pages: 1,
      page: 1,
      headers: [
        {
          text: "Stovo Nr.",
          value: "stand_number",
          width: 10,
        },
        {
          text: "Užsakymo Nr.",
          value: "supplier_order",
          width: 20,
        },
        {
          text: "Pos. Nr.",
          value: "supplier_position",
          width: 5,
        },
        {
          text: "Matmenys",
          unsortable: true,
          width: 20,
        },
        {
          text: "Gaminys",
          value: "type",
          width: 25,
        },
        {
          text: "Užsakovo užsakymo nr.",
          value: "customer_order",
          width: 10,
        },
        {
          text: "Užsakovo inf.",
          value: "customer_position",
          width: 5,
        },
      ],
    };
  },
  watch: {
    page(val) {
      window.scrollTo(0, 0);
      this.$emit("pageChanged", val);
    },
  },
  methods: {
    updatePages(pages, page) {
      this.pages = pages;
      this.page = page;
    },
  }
};
</script>

<style scoped>
#glass-units-mobile {
  position: relative;
  width: calc(100% - 50px);
  left: 25px;
}
.glass-unit-card {
  margin-top: 10px;
  padding-left: 5px;
  padding-top: 10px;
}
.glass-unit-info {
  font-weight: 450;
}
.filtered-count {
  font-weight: 600;
  font-size: 20px;
  margin-top: 2px;
}
</style>